export default __webpack_public_path__ + "f76e789c9e03f720905a931a787ffc19.png";